// extracted by mini-css-extract-plugin
module.exports = {"Caption":"Caption_Caption__q824t"};